import {
    PositionEntryState,
    initialPositionEntryState,
} from './PositionEntryState';
import { PositionEntryAction, PositionEntryActionType } from './actions';
import { Reducer } from 'redux';

export const positionEntryReducer: Reducer<
    PositionEntryState,
    PositionEntryAction
> = (state = initialPositionEntryState, action) => {
    switch (action.type) {
        case PositionEntryActionType.POSITION_ENTRY_INPUT_SET: {
            return {
                ...state,
                positionInput: action.payload!,
            };
        }
        case PositionEntryActionType.POSITION_ENTRY_SET: {
            return {
                ...state,
                position: action.payload!,
            };
        }
        case PositionEntryActionType.POSITION_ENTRY_CLEAR: {
            if (action.payload!.clearInput) {
                return initialPositionEntryState;
            }
            return {
                ...state,
                position: undefined,
            };
        }
    }
    return state;
};
